import { tv } from 'tailwind-variants';

import { baseCarouselStyles } from '../../lib/UiReviewLightboxBase.styles';

export const styles = tv({
  extend: baseCarouselStyles,
  slots: {
    base: '',
    viewport: 'w-full px-10'
  }
});
